import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function AdminGuide() {
  const [open, setOpen] = useState(false);

  return (
    <section className="no-print rounded-xl border border-leather bg-leather/40 p-5">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 text-left"
      >
        <h2 className="text-lg font-semibold text-gold">Owner Operations Guide</h2>
        <span className="text-gold/80 text-sm shrink-0">{open ? '▼' : '▶'}</span>
      </button>
      {open && (
        <div className="mt-4 space-y-6 text-sm text-station-muted">
          <div>
            <h3 className="font-medium text-gold/90 mb-1">Managing User Rights</h3>
            <p className="mb-2">
              Go to <Link to="/admin/users" className="text-gold hover:text-gold-light underline">Admin · Users</Link> to manage who can access the portal.
              Add users as <strong className="text-gold/80">admin</strong> (owner) or <strong className="text-gold/80">partner</strong>, assign roles, and use <strong className="text-gold/80">Add Rights</strong> to grant or revoke access.
            </p>
          </div>
          <div>
            <h3 className="font-medium text-gold/90 mb-1">Adjusting Commissions</h3>
            <p className="mb-2">
              In <Link to="/admin/users" className="text-gold hover:text-gold-light underline">Admin · Users</Link>, open a partner user and edit the <strong className="text-gold/80">commission_rate</strong> field (e.g. 0.03 for 3%). Save to apply.
            </p>
          </div>
          <div>
            <h3 className="font-medium text-gold/90 mb-1">Reviewing R2 Resumes</h3>
            <p className="mb-2">
              Go to <Link to="/admin/screening" className="text-gold hover:text-gold-light underline">Admin · Screening</Link> to see applicants. Use <strong className="text-gold/80">View Resume</strong> to open the R2 resume for each applicant.
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
